import { useSearchStore } from '../../stores/search-store.js';
import { useBarClause } from '../../hooks/useBarClause.js';
import { useAdvancedSubmit } from '../../hooks/useAdvancedSubmit.js';

const inputClass =
  'bg-gray-800 border border-gray-700 rounded-lg px-2.5 py-1.5 text-xs text-gray-300 placeholder-gray-600 focus:outline-none focus:border-orange-500 transition-colors w-full';

export function CardNameInput() {
  const cardName = useSearchStore((s) => s.advancedFilters.cardName);
  const setAdvancedFilter = useSearchStore((s) => s.setAdvancedFilter);
  const { writeClause } = useBarClause();
  const { submit } = useAdvancedSubmit();

  const syncToBar = (value: string) => {
    const v = value.trim();
    if (!v) { writeClause('name:', null); return; }
    writeClause('name:', v.includes(' ') ? `"${v}"` : v);
  };

  return (
    <div className="space-y-1">
      <label className="text-[10px] text-gray-500 uppercase tracking-wider">Card Name</label>
      <input
        type="text"
        value={cardName}
        onChange={(e) => setAdvancedFilter('cardName', e.target.value)}
        onBlur={() => syncToBar(cardName)}
        onKeyDown={(e) => { if (e.key === 'Enter') { syncToBar(cardName); submit(); } }}
        placeholder="e.g. Lightning"
        className={inputClass}
      />
    </div>
  );
}
